import { mapGetters } from 'vuex'
import {
  commonUtil,
  countryUtil,
  currencyUtil,
  countryCallingCodeUtil
} from '@/util'
import {
  ExpansionPanel,
  InputFormNew,
  PhoneNumberInput,
  PostalCodeArea
} from '@/components/items'

import detail from './detail'

export default {
  components: {
    ExpansionPanel,
    InputFormNew,
    PhoneNumberInput,
    PostalCodeArea
  },
  props: {
    clientInfo: {}
  },
  data: () => {
    return {
      isEdit: { default: false },

      // Design
      inputFormStyle: {
        rowHeight: '40px',
        titleCols: 4,
        contentsCols: 12 - 4,
        inputItemHeight: '32px'
      },
      clientDetail: detail.detail,

      clientData: {
        clientInfo: {},

        invoiceInfo: {
          storageMoveDate: '',
          trackingNumber: '',
          storageAdjustReason: {},
          storageAdjustReasonTarget: ''
        },
        receiverInfo: {
          fullName: '',
          phone: {
            countryCode: {},
            phoneNumber: ''
          },
          country: {},
          postalCode: '',
          region: '',
          address1: '',
          address2: ''
        }
      }
    }
  },
  created() {
    this.getClientData()
  },
  methods: {
    ...mapGetters('Common', [
      'getCountryListFromState',
      'getCountryCallingCodeJpFromState',
      'getCountryJpFromState',
      'getCurrencyJpFromState'
    ]),

    getClientData() {
      this.clientData.clientInfo = this.clientInfo
      ;[this.clientData.invoiceInfo].map((ele) => {
        ele.storageMoveDate = commonUtil.getToday()
      })

      if (!Object.keys(this.clientInfo).length) {
        ;[this.clientData.receiverInfo.phone].map((ele) => {
          ele.countryCode = this.getCountryCallingCodeJpFromState()
        })
        ;[this.clientData.receiverInfo].map((ele) => {
          ele.country = this.getCountryJpFromState()
        })
        return
      }

      const clientInfoTmp = { ...this.clientInfo }

      if ('storageRecipientId' in clientInfoTmp) {
        this.clientData.receiverInfo = {
          fullName: clientInfoTmp.name,
          phone: {
            countryCode: countryCallingCodeUtil.getPhoneNumberCountryIdInfo(
              clientInfoTmp.phoneNumberCountryId
            ),
            phoneNumber: clientInfoTmp.phoneNumber
          },
          country: countryUtil.getCountryIdInfo(clientInfoTmp.countryId),
          postalCode: clientInfoTmp.postalCode,
          region: countryUtil.getRegionInfo(
            clientInfoTmp.countryId,
            clientInfoTmp.regionId
          ),
          address1: clientInfoTmp.address1,
          address2: clientInfoTmp.address2
        }
      }
    },

    onClickPostalCodeInvoiceInfo(...args) {
      const [address] = args
      this.setPostalCode(address, 'invoiceInfo')
    },
    onClickPostalCodeReceiverInfo(...args) {
      const [address] = args
      this.setPostalCode(address, 'receiverInfo')
    },
    setPostalCode(address, infoName) {
      this.clientData[infoName].region = countryUtil.getRegionInfoByName(
        this.clientData[infoName].country.value,
        address.region
      )
      this.clientData[infoName].address1 = address.locality
      this.clientData[infoName].address2 = address.street
    }
  },

  watch: {
    clientInfo: {
      deep: true,
      handler(newVal, oldVal) {
        this.getClientData()
      }
    },
    clientData: {
      deep: true,
      handler(newVal, oldVal) {
        this.$emit('change', newVal)
      }
    }
  }
}
